export default {"src":"/_next/static/image/public/images/ic_left_pagination_arrow_green.bc2670858c969e9e9c606488bb998c78.svg","height":15,"width":8};